import { styles } from '@app/services/app-styles.service';

const badge = {
    root: {
        borderRadius: '10rem',
    },
    warn: {
        background: styles().warn,
        color: '#fff',
    },
};

export default badge;
